export default "__VITE_ASSET__O9R0ibNQ__"